import EAButton from 'components/common/EAButton';
import i18next from 'i18next';
import { isEmpty } from 'lodash';
import { useFormContext } from 'react-hook-form';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';

const EcovadisDialogButtons = ({
  cancelLabel = 'cancel',
  onCancel = () => {},
  validateLabel = 'validate',
  onValidate = () => {},
  shouldTrigger = true,
  isLoading = false
}) => {
  const { classes } = useStyles();

  const {
    trigger,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={classes.btnWrapper}>
      <EAButton
        onClick={(e) => {
          e.preventDefault();
          onCancel();
        }}
        content={i18next.t(cancelLabel)}
        colorVariant="secondary"
      />

      <EAButton
        onClick={(e) => {
          e.preventDefault();
          if (shouldTrigger) {
            trigger().then((canContinue) => canContinue && onValidate());
          } else {
            onValidate();
          }
        }}
        validateLoading={isLoading}
        disabled={!isEmpty(errors)}
        content={i18next.t(validateLabel)}
        colorVariant={'primary'}
      />
    </div>
  );
};

export default EcovadisDialogButtons;
